import Icon from '../components/Icon.vue'

Icon.register({
  crown: {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M528 448H112C103.2 448 96 455.2 96 464V496C96 504.8 103.2 512 112 512H528C536.8 512 544 504.8 544 496V464C544 455.2 536.8 448 528 448zM592 128C565.5 128 544 149.5 544 176 544 183.1 545.6 189.7 548.4 195.8L476 239.2C460.6 248.4 440.7 243.2 431.8 227.6L350.3 85C361 76.2 368 63 368 48 368 21.5 346.5 0 320 0S272 21.5 272 48C272 63 279 76.2 289.7 85L208.2 227.6C199.3 243.2 179.3 248.4 164 239.2L91.7 195.8C94.4 189.8 96.1 183.1 96.1 176 96.1 149.5 74.6 128 48.1 128S0 149.5 0 176 21.5 224 48 224C50.6 224 53.2 223.6 55.7 223.2L128 416H512L584.3 223.2C586.8 223.6 589.4 224 592 224 618.5 224 640 202.5 640 176S618.5 128 592 128z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/crown.js
// module id = 7CyZ
// module chunks = 144